export const EMAIL_REGEX =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
export const NUMBER_REGEX = /^[0-9]*$/;
export const NUMBER_REGEX_NO_ZERO_HEADER = /^[1-9][0-9]*$/;
export const ALPHABET_REGEX = /^[A-Za-z_ ]+$/;
